import styled from "styled-components";
import { FlexColumn, FlexRowDiv } from "../common.styles";
import { colors } from "healthex-common/colors";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "../HXMobilePage.styles";
import { Text } from "../HXDesktopPage.styles";
import CircularProgress from "@mui/material/CircularProgress";
export const NotificationPreviewDialogParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) `
    flex: 1;
    gap: 16px;
    min-width: 680px;
    height: auto;
`;
export const NotificationPreviewDialogContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    flex: 1;
    padding: 16px 24px;
`;
export const NotificationPreviewDialogTabs = styled(FlexRowDiv) `
    gap: 0;
    background-color: ${colors.navy_4};
    border: 1px solid ${colors.black_12};
    border-radius: 4px;

    button {
        flex: 1;
        border-radius: 4px;
        border: 1px solid ${colors.black_12};
        color: ${colors.black_main};

        &.MuiButton-contained {
            background-color: ${colors.white_main};
        }

        &.MuiButton-outlined {
            background-color: transparent;
            border: none;
        }
    }
`;
export const NotificationPreviewDialogTabContent = styled(FlexColumn) `
    flex: 1;
    padding-top: 16px;
`;
export const PreviewContentContainer = styled(FlexColumn) `
    flex: 1;
    overflow: auto;
    border: 1px solid ${colors.black_12};
    border-radius: 4px;
    padding: 16px;
    gap: 16px;
    min-height: 0;
`;
export const PreviewSubjectContainer = styled(FlexColumn) `
    gap: 4px;
`;
export const PreviewEmailContent = styled.div ``;
export const PreviewSMSContainer = styled(FlexColumn) `
    flex: 1;
    gap: 16px;
    padding: 16px;
`;
export const PreviewSMSContent = styled(Text) `
    background-color: #e9e9eb;
    border-radius: 32px;
    padding: 18px;
    max-width: 410px;
    position: relative;

    /* Speech bubble tail/arrow at left bottom */
    &::before {
        content: "";
        position: absolute;
        bottom: 10px;
        left: -18px;
        width: 0;
        height: 0;
        border: 24px solid transparent;
        border-right-color: #e9e9eb;
        border-left: 0;
        border-bottom: 0;
        transform: rotate(-15deg);
    }
`;
export const Spinner = styled(CircularProgress).attrs({ size: 32 }) ``;
export const PreviewSMSLink = styled.span `
    color: #007aff;
    text-decoration: underline;
    cursor: default;
`;
